const initialState = () => ({
  customerTableOptions: {
    page: 1,
    itemsPerPage: 25,
    totalItems: 0,
    sortBy: [],
    sortDesc: [],
  },
  deactivatedTableOptions: {
    page: 1,
    itemsPerPage: 25,
    totalItems: 0,
    sortBy: [],
    sortDesc: [],
  },
  filters: {
    free: false,
    priority: false,
    prevent: false,
    standard: false,
    partner: false,
    pilot: false,
  },
  customersCount: {
    totalMembersCount: 0,
    lastMonthMembersCount: 0,
  },
  inviteCustomer: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  },
  selectedPartnerSettings: {},
  profileCompleteCount: 0,
  profileIncompleteCount: 0,
  baseProfileCount: 0,
  activeProfileTab: 'complete',
  selectedPlanIds: [],
  selectedMembershipTypes: [],
  hasVirtualVisit: null,
  customerTableSearch: '',
  deactivatedTableSearch: '',
  allCustomers: [],
  allProspects: [],
  profileCompleted: [],
  profileIncompleted: [],
  baseProfile: [],
  tableData: [],
  sortedCorporation: [],
  selectedCorp: null,
  loading: true,
  deactivatedProfiles: [],
  newCustomersUpload: [],
  parsingErrorObj: {},
  selectedPlan: {},
  selectedProspect: {},
  actionModalView: '',
  showActionModal: false,
});

export default initialState;
